import React, { useEffect, useState } from 'react';
import Lottie from 'react-lottie';

const LottieAnimation = ({ animationFile, width = 400, height = 300, loop = true, autoplay = true }) => {
  const [animationData, setAnimationData] = useState(null);

  useEffect(() => {
    // Fetch the Lottie JSON file from the public folder
    fetch(`/BaloonAnimation.json`) // This path should be relative to the public folder
      .then((response) => response.json())
      .then((data) => setAnimationData(data))
      .catch((error) => console.error('Error loading the Lottie animation:', error));
  }, [animationFile]);

  if (!animationData) {
    return <div>Loading animation...</div>; // Display loading message while fetching
  }

  const defaultOptions = {
    loop,
    autoplay,
    animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  };

  return <Lottie options={defaultOptions} height={height} width={width} />;
};

export default LottieAnimation;
